<template>
  <div ref="background" class="background" @click="onBackgroundClick">
    <template v-if="loader.loaded && !loader.show">
      <!-- assistant 的 header 預留空間 -->
      <!-- 主要放 Message 的區塊 -->
      <div
        ref="view"
        style="overflow-x:hidden; padding-bottom:4rem; margin-bottom: 100px;"
        @contextmenu.prevent
      >
        <v-container
          fluid
          :style="{ display: 'inline-block' }"
          style="padding: 10px;"
        >
          <v-row>
            <v-col cols="12">
              <!-- START -- Message -->
              <template v-for="(message, i) in scene.messages">
                <div class="msg ml-2 mr-3 mb-2 noselect" :key="'m-' + i">
                  <div class="mb-1 d-flex justify-space-between">
                    <!-- 人物名稱的選單 -->
                    <div class="role-name-selector-group">
                      <select
                        class="role-name role-name-selector"
                        v-model="message.sender"
                      >
                        <template v-for="name in nameChips.list">
                          <option :key="name" :value="name">{{ nameChipText(name) }}</option>
                        </template>
                      </select>
                      <v-btn icon dark x-small href="javascript:;">
                        <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                      </v-btn>
                    </div>
                    <!-- 顯示 message 的 ID (並提供點擊可修改的功能) -->
                    <!-- START的ID不應被修改 -->
                    <span
                      class="msg-id"
                      v-show="message.showId"
                      @click="
                        message.id !== 'START' &&
                          enableEditMode(message, i, 'id')
                      "
                      >ID: &lt;{{ message.id }}&gt;</span
                    >
                  </div>
                  <div v-if="message.next" class="mb-1">
                    <span
                      class="hover c-pointer"
                      @click="enableEditMode(message, i, 'next')"
                      >TO: &lt;{{ message.next }}&gt;</span
                    >
                  </div>

                  <long-touch @touchlong="showMessageMenu(i, $event)">
                    <div
                      class="content"
                      :class="[
                        edit.target === message ? 'content-selected' : undefined,
                        message.sender === '$narrator' ? 'narrator' : undefined
                      ]"
                      style="min-width:50px;"
                      @click="
                        if (!$event.defaultPrevented) {
                          edit.target !== message
                            ? enableEditMode(message, i, 'content')
                            : clearEditSelect()
                        }
                      "
                      @contextmenu.prevent="showMessageMenu(i, $event)"
                    >
                      <div v-if="message.ssml">
                        <span class="grey--text">ssml:</span>
                        <span class="blue--text text--lighten-1">{{message.ssml}}</span>
                      </div>
                      <div v-if="message._contentHtml">
                        <!-- message 的 content -->
                        <span v-html="message._contentHtml || '&nbsp;'"></span>
                        <!-- 在 message 底下顯示 hint -->
                        <template v-if="message.hint">
                          <!-- <hr
                            style="border-style:solid; border-color:rgba(200,200,200,0.7);"
                          /> -->
                          <v-divider></v-divider>
                          <span style="color: gray">{{ message.hint }}</span>
                        </template>
                        <!-- <template v-if="message.hint">
                        </template>-->
                      </div>
                      <!-- 顯示音檔的相關資訊 -->
                      <template v-if="message.audio">
                        <v-divider v-if="message.content"></v-divider>
                        <div
                          class="ar-player-wrapper"
                          @click="choiceRecord(message.audio)"
                          v-if="!message.audio.uploading"
                        >
                          <audio-player :ref="`audio-${message.id}`" :record="message.audio" />
                        </div>
                        <!-- 音檔上傳進度條 -->
                        <div class="pa-3" v-if="message.audio.uploading">
                          <v-progress-linear
                            :value="message.audio.uploadProgress"
                            :color="message.audio.error ? 'pink' : undefined"
                            height="12"
                            style="min-width:100px"
                          >
                            <template v-slot="{ value }">
                              <span class="overline">
                                <template v-if="message.audio.error">
                                  {{message.audio.errorMsg}}
                                </template>
                                <template v-else>
                                  uploading : {{Math.ceil(value)}}%
                                </template>
                              </span>
                            </template>
                          </v-progress-linear>
                        </div>
                      </template>
                    </div>
                  </long-touch>
                </div>
                <!-- START selection 的 card -->
                <selection-card
                  :key="'s-' + i"
                  :message="message"
                  :msgIndex="i"
                  @show-menu="onSelectionCardEvent"
                >
                </selection-card>
                <!-- END selection 的 card -->
              </template>
              <!-- END -- Message -->
              <!-- <div class="ar-records">
                <div
                  class="ar-records__record"
                  :key="record.id"
                  v-for="(record, idx) in recordList"
                  @click="choiceRecord(record)">
                    <div
                      class="ar__rm"
                      v-if="record.id === selected.id"
                      @click="removeRecord(idx)">&times;</div>
                    <audio-player :record="selected"/>
                    <div class="ar__text">{{record.duration}}</div>
                </div>
              </div> -->
              <!-- 最後一則Message的底下要有 + 的按鈕 -->
              <div style="text-align:center; margin-top:10px;">
                <v-btn
                  icon
                  @click="
                    enableCreateMode(scene.messages.length - 1)
                    $refs.inputField.focus()
                  "
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- =============================== ##MENU =============================== -->
      <!-- #MENU 浮動選單 for selection -->
      <v-menu
        z-index="200"
        v-model="selectionMenu.show"
        :position-x="selectionMenu.x"
        :position-y="selectionMenu.y"
        fixed
        offset-y
      >
        <v-list>
          <v-list-item @click="removeSelectionAlias()">
            <v-list-item-title>remove</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- #MENU 浮動選單 for selection card-->
      <v-menu
        z-index="200"
        v-model="selectionCardMenu.show"
        :position-x="selectionCardMenu.x"
        :position-y="selectionCardMenu.y"
        fixed
        offset-y
      >
        <v-list>
          <v-list-item @click="removeSelection()">
            <v-list-item-title>remove</v-list-item-title>
          </v-list-item>
          <v-list-item @click="newSelection()">
            <v-list-item-title>new selection</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- #MENU 浮動選單 for selection action -->
      <v-menu
        z-index="200"
        v-model="selectionActionMenu.show"
        :position-x="selectionActionMenu.x"
        :position-y="selectionActionMenu.y"
        fixed
        offset-y
      >
        <v-list>
          <v-list-item>
            <v-list-item-title>TO</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-title>SET-VAR</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>CHANGE-VAR</v-list-item-title>
          </v-list-item>-->
        </v-list>
      </v-menu>
      <!-- #MENU 浮動選單 for message -->
      <v-menu
        z-index="200"
        v-model="messageMenu.show"
        :position-x="messageMenu.x"
        :position-y="messageMenu.y"
        fixed
        offset-y
      >
        <v-list v-if="messageMenu.msg">
          <v-list-item @click="enableCreateMode(messageMenu.index)">
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.insertMessage')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="setMsgSSML({ prompt: true })">
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.setMsgSSML')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 添加分支選項 -->
          <v-list-item
            v-if="messageMenu.msg.selections.length === 0"
            @click="initMsgSelections()"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.addSelection')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 使用進階問答功能 -->
          <v-list-item
            v-if="messageMenu.msg.selections.length === 0"
            @click="initMsgSelections({ advance: true })"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.useAdvanceSelection')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="messageMenu.msg.selections.length > 0 && messageMenu.msg.selectMode === 'ai'"
            @click="initMsgSelections({ advance: true })"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.setupAdvanceSelection')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 移除所有分支選項 -->
          <v-list-item
            v-if="messageMenu.msg.selections.length > 0"
            @click="messageMenu.msg.selections = []"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.removeAllSelection')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 顯示或隱藏 ID -->
          <v-list-item
            @click="messageMenu.msg.showId = !messageMenu.msg.showId"
          >
            <v-list-item-content>
              <v-list-item-title
                >{{
                  messageMenu.msg.showId ? $t('Editor.hide') : $t('Editor.show')
                }}
                id</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <!-- 設定 JUMP 功能 -->
          <v-list-item
            v-if="messageMenu.msg.selections.length === 0"
            @click="showSetMessageNextPrompt()"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.jump')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 添加提示 -->
          <v-list-item @click="setMessageHint({ prompt: true })">
            <v-list-item-content>
              <v-list-item-title>
                {{ messageMenu.msg.hint ? $t('Editor.set') : $t('Editor.add') }}
                {{$t('Editor.hint')}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- 刪除 -->
          <v-list-item
            v-if="typeof messageMenu.msg.hint === 'string'"
            @click="setMessageHint({ remove: true })"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.remove')}} {{$t('Editor.hint')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="messageMenu.msg.audio"
            @click="removeMessageAudio()"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.remove')}} {{$t('Editor.audio')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="removeMessage(messageMenu.index)">
            <v-list-item-content>
              <v-list-item-title>{{$t('Editor.remove')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item @click="showUpload()">
            <v-list-item-content>
              <v-list-item-title>ADD File</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
      <!-- #MENU 浮動選單 for role -->
      <v-menu
        z-index="200"
        v-model="roleMenu.show"
        :position-x="roleMenu.x"
        :position-y="roleMenu.y"
        fixed
        offset-y
      >
        <v-list>
          <v-list-item @click="showRoleChangePrompt()">
            <v-list-item-content>
              <v-list-item-title>change</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showRoleAddPrompt()">
            <v-list-item-content>
              <v-list-item-title>add</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showRoleAddPrompt()">
            <v-list-item-content>
              <v-list-item-title>remove</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- =============================== ##FOOTER =============================== -->
      <!-- 底下的編輯框 -->
      <div class="footer">
        <!-- 這邊放工具列 -->
        <div class="d-flex justify-space-between toolbar">
          <!-- 放角色名稱的 chip -->
          <span
            class="name-chips"
            style="padding-top:5px; max-width:50%; overflow-x:auto; white-space:nowrap;"
          >
            <template v-for="name in nameChips.list">
              <long-touch
                type="span"
                @touchlong="showSelectionCardMenu(i, j, $event)"
                :key="name"
              >
                <v-chip
                  small
                  class="mr-3"
                  :class="{ 'indigo darken-2': name === nameChips.lastChoice }"
                  :key="name"
                  @click="onNameChipClick(name)"
                  @contextmenu.prevent="showRoleMenu(name, $event)"
                  >{{ nameChipText(name) }}</v-chip
                >
              </long-touch>
            </template>
            <v-chip small class="pa-2" @click="showRoleAddPrompt(name)"
              >+</v-chip
            >
          </span>
          <span style="text-align:right;">
            <!-- 主選單按鈕 -->
            <v-btn icon @click="mainMenu.show = !mainMenu.show">
              <v-icon :color="styles.iconColor">mdi-view-grid-outline</v-icon>
            </v-btn>
          </span>
        </div>
        <div class="d-flex align-center">
          <!-- 畫面最底下的輸入框 -->
          <textarea
            class="edit-tmp-input"
            style="resize:none;"
            :style="{ height: styles.inputFieldHeight }"
            ref="inputField"
            v-model="edit.tmpInput"
            type="text"
            @input="editInputKeyup()"
            @keyup.enter="editInputEnter($event)"
          />
          <v-btn icon small @click="toggleShowRecorder()">
            <icon-button class="icon-mic" :name="'mic'" />
          </v-btn>
          <!-- 輸入框旁邊的送出按鈕 -->
          <v-btn icon small @click="editInputSubmit()">
            <v-icon :color="styles.iconColor">mdi-chevron-right-circle</v-icon>
          </v-btn>
        </div>
        <div class="recorder-area" v-if="showRecorder">
          <audio-recorder
            @submit-record="onAudioRecordSubmit"
            @submit-file="onAudioFileSubmit"
            upload-url="some url"
            filename="ninja"
            format="wav"
            :attempts="10"
            :time="2"
            :bit-rate="192"
          />
        </div>
      </div>
    </template>
    <!-- =============================== ##LOADER =============================== -->
    <transition name="fade">
      <v-dialog
        v-model="loader.show"
        hide-overlay
        :persistent="!loader.loaded"
        max-width="300"
      >
        <v-card color="secondary">
          <v-card-text class="white--text" style="padding-top: 15px">
            <transition name="fade">
              <div v-if="!loader.loaded">
                <span v-text="loader.text"></span>
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </div>
            </transition>
          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>
    <simple-prompt ref="prompt" />
    <!-- 主選單 -->
    <v-dialog v-model="mainMenu.show" scrollable max-width="300px">
      <v-card>
        <v-list-item @click="reloadPage()">
          <v-list-item-content>
            <v-list-item-title>refresh</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="
            uploadScene()
            mainMenu.show = false
          "
        >
          <v-list-item-content>
            <v-list-item-title>save</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$dev" @click="prompt('test').then(log)">
          <v-list-item-content>
            <v-list-item-title>test</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <!-- 上傳表單 -->
    <v-dialog max-width="50%" v-model="uploadShow">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            manageFiles.length ? 'Manage File' : 'Upload File'
          }}</span>
        </v-card-title>
        <v-card-text>
          <MUploader
            @loadManageFiles="loadManageFiles"
            :manageFiles="manageFiles"
            :upload-form="uploadForm"
          ></MUploader>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="uploadShow = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- .background -->
</template>

<script>
// import { VueTyper } from 'vue-typer'
import _ from 'lodash'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
import Scene from '@/lib/Scene'
import Message from '@/lib/Message'
import Screenplay from '@/lib/Screenplay'
import LongTouch from '@/components/LongTouch'
import SimplePrompt from '@/components/SimplePrompt'
import MUploader from '@/components/MUploader'
import { queryFile, uploadAudio } from '@/lib/media/upload-file'
import IconButton from '@/components/AudioRecorder/icon-button'
import AudioRecorder from '@/components/AudioRecorder/RecorderV2'
import AudioPlayer from '@/components/AudioRecorder/PlayerV2'
import SelectionCard from '@/components/Game/Editor/SelectionCard'
import UploadParam from '@/lib/media/UploadParam'
import mime from 'mime'

export default {
  name: 'edit-scene',
  components: {
    LongTouch,
    MUploader,
    SimplePrompt,
    IconButton,
    AudioRecorder,
    AudioPlayer,
    SelectionCard
  },
  computed: {
    iconButtonType() {
      return this.isRecording && this.isPause
        ? 'mic'
        : this.isRecording
          ? 'pause'
          : 'mic'
    }
  },
  watch: {
    'loader.show'(show) {}
  },
  data: () => {
    return {
      // 對話框底下的錄音區塊的相關配置
      // 是否顯示底下的 錄音框
      showRecorder: false,
      recorderHeaders: [],
      recordList: [],
      selected: {},
      // ADD FILE 的相關配置
      uploadForm: {
        sid: '',
        scene: '',
        message_id: ''
      },
      manageFiles: [],
      uploadShow: false,
      // 目前劇本的 id , mounted 後會取得內容
      screenplayId: null,
      // 目前編輯的場景, mounted 後會取得內容
      scene: null,
      styles: {
        iconColor: '#FFAD1F',
        // 底下輸入框的高度
        inputFieldHeight: 'calc(1.5rem + 4px)'
      },
      // "底下的編輯框"的相關設定
      edit: {
        mode: 'create' || 'edit',
        field: null, // 'sender' || 'content'
        // 當前編輯的 message
        target: null,
        index: -1,
        tmpInput: ''
      },
      // 浮動選單 for selection
      selectionMenu: {
        x: 0,
        y: 0,
        show: false,
        mIndex: 0,
        sIndex: 0
      },
      // 浮動選單 for selection card
      selectionCardMenu: {
        x: 0,
        y: 0,
        show: false,
        mIndex: 0,
        sIndex: 0
      },
      // 浮動選單 for selection action
      selectionActionMenu: {
        x: 0,
        y: 0,
        show: false,
        msg: null,
        selection: null
      },
      // 浮動選單 for message
      messageMenu: {
        x: 0,
        y: 0,
        show: false,
        msg: null
      },
      roleMenu: {
        x: 0,
        y: 0,
        show: false,
        role: null
      },
      // 主要選單 (放"保存"之類的按鈕)
      mainMenu: {
        show: false
      },
      nameChips: {
        list: [],
        lastChoice: null
      },
      test: 0,
      loader: {
        text: '',
        show: true,
        loaded: false
      }
    }
  },
  created(){
    this.showLoader({ text: 'Loading', loaded: false })
  },
  mounted() {
    // this.$nextTick(() => {
    this.$store.commit(
      'appbar/backTo',
      `/edit?sid=${this.$route.query.sid || 'test'}`
    )
    this.$store.commit(
      'appbar/setOptions',
      [
        {
          key: 'show-trial-game',
          text: 'play game'
        }
      ]
    )
    this.$appbarCallback = this.appbarCallback.bind(this)
    this.$bus.$on('appbar-option-click', this.$appbarCallback)
    util
      .delay(100)
      // .then(()=>gameLoader.load('newgame.js'))
      .then(() => {
        this.screenplayId = this.$route.query.sid || 'test'
        let sceneId = this.$route.query.scene || 'START'
        return gameLoader
          .loadScene(this.screenplayId, sceneId)
          .catch(() => Promise.resolve(null))
      })
      .then((scene) => {
        // 自動產生新的場景
        if (!scene) {
          if (!this.$route.query.sid) {
            throw new Error('screenplay no select')
          }
          throw new Error('scene is null')
        }
        this.scene = scene
        // 重設角色姓名的chip
        this.resetNameChips()
        this.hideLoader({ loaded: true })
      })
      .catch((e) => {
        console.log('SceneEditor errors:')
        console.error(e)
      })
  },
  beforeDestroy() {
    this.$bus.$off('appbar-option-click', this.$appbarCallback)
  },
  methods: {
    appbarCallback(btn, event){
      console.log('appbarCallback', btn)
      if(btn.key === 'show-trial-game'){
        this.$router.push(`/game/dev?sid=${this.screenplayId}`)
      }
    },
    showLoader(opts = {}){
      let { text, loaded } = opts
      text = text || 'Loading'
      if(typeof loaded === 'boolean'){
        this.loader.loaded = loaded
      }
      this.loader.show = true
      this.loader.text = text
    },
    hideLoader(opts = {}){
      let { loaded } = opts
      if(typeof loaded === 'boolean'){
        this.loader.loaded = loaded
      }
      this.loader.show = false
    },
    recorderCallback(e) {
      console.log('recorderCallback', e)
    },
    /**
     * recorder 的 callback
     * 當提交檔案
     */
    onAudioFileSubmit(record){
      record.clearSelectedFile()
      return this.uploadRecord({
        blob: record.file,
        duration: record.duration,
        url: record.url,
        title: '$file'
      })
    },
    /**
     * recorder 的 callback
     * 當收到錄音檔
     */
    onAudioRecordSubmit(record) {
      return this.uploadRecord({
        blob: record.blob,
        duration: record.duration,
        url: record.url,
        title: '$record'
      })
    },
    uploadRecord(audio){
      console.log('uploadRecord', audio)
      audio.uploadProgress = 0
      audio.uploading = true
      let msg
      if (this.edit.target) {
        msg = this.edit.target
        this.$set(this.edit.target, 'audio', audio)
      } else {
        msg = new Message({ audio })
        this.scene.messages.push(msg)
      }
      console.log('onAudioListUpdate - msg', msg)
      let ext = mime.getExtension(audio.blob.type)
      return uploadAudio({
        sid: this.screenplayId,
        scene: this.scene.id,
        message_id: msg.id,
        file: audio.blob,
        size: audio.blob.size,
        title: audio.title,
        name: `${audio}.${ext}`,
        extension: ext,
        type: 'audio'
      }, (progress)=>{
        // 上傳進度設定成佔總進度的 90%
        audio.uploadProgress = progress * 0.9
        console.log('progress', audio.uploadProgress)
      }).then((res)=>{
        // 這部分的API 要額外判斷 code 才能判斷是否成功
        if(res.data && res.data.code === 0){
          return res
        }else{
          let err = new Error()
          err.data = res.data
          return Promise.reject(err)
        }
      }).then((res)=>{
        let info = res.data.data
        audio.uploadProgress = 100
        audio.uploading = false
        audio.id = info.id
        audio.info = info
        msg.resetAudioUrl()
        console.log('progress', audio.uploadProgress)
        console.log('upload audio success', res.data)
        return this.uploadScene()
      }).then(()=>{
        let [ player ] = this.$refs[`audio-${msg.id}`]
        if(player){
          player.reload()
        }
      }).catch((e)=>{
        audio.uploadProgress = 100
        audio.error = e
        if(e.data){
          audio.errorMsg = e.data.msg
        }else{
          audio.errorMsg = e.message || '上傳失敗'
        }
        console.error(e)
      })
    },
    removeRecord(idx) {
      this.recordList.splice(idx, 1)
      this.$set(this.selected, 'url', null)
      this.$eventBus.$emit('remove-record')
    },
    choiceRecord(record) {
      if (this.selected === record) {
        return
      }
      this.selected = record
      this.selectRecord && this.selectRecord(record)
    },
    toggleShowRecorder() {
      this.showRecorder = !this.showRecorder
      if(!this.showRecorder){
        // 關起來的時候自動清除
        this.$refs['audio-recorder'].clearFile()
      }
    },
    showUpload() {
      this.uploadForm = {
        sid: this.$route.query.sid,
        scene: this.$route.query.scene,
        message_id: this.messageMenu.msg.id
      }
      if (!this.uploadForm.sid) {
        this.$message.error('劇本id為空或者讀取錯誤')
        return
      }
      if (!this.uploadForm.scene) {
        this.$message.error('場景id為空或者讀取錯誤')
        return
      }
      if (!this.uploadForm.message_id) {
        this.$message.error('消息id為空或者讀取錯誤')
        return
      }
      this.loadManageFiles()
    },
    loadManageFiles() {
      // 取得 message 的 media list
      return queryFile(this.uploadForm)
        .then((res) => {
          console.log(res)
          this.manageFiles = res.data.data || []
          this.uploadShow = true
        })
        .catch((err) => {
          console.log(err)
          this.uploadShow = true
        })
    },
    prompt(opts = {}) {
      if (this.$refs.prompt.prompt) {
        return this.$refs.prompt.prompt(opts)
      }
    },
    reloadPage() {
      location.reload()
    },
    /**
     * 掃描該場景的Message裡所有的角色並回傳
     * @returns {String[]}
     */
    resetNameChips() {
      let map = {}
      for (let msg of this.scene.messages) {
        if(msg.sender){
          map[msg.sender] = true
        }
      }
      map['$narrator'] = true
      this.nameChips.list = Object.keys(map)
      return this.nameChips.list
    },
    log() {
      console.log.apply(console, Array.from(arguments))
    },
    initScene(scene) {
      for (let msg of scene.messages) {
        this.$set(msg, '_page', 0)
      }
    },
    uploadScene() {
      let newScene = new Scene(JSON.parse(JSON.stringify(this.scene)))
      for (let msg of newScene.messages) {
        if (!msg.validate()) {
          // TODO
          break
        }
        delete msg._page
        delete msg.idEdited
      }
      gameLoader.saveScene(this.screenplayId, newScene)
    },
    sceneToJSON(_scene) {
      let scene = _.merge({}, _scene)
      for (let msg of scene.messages) {
        delete msg._page
      }
      return JSON.stringify(scene)
    },
    onBackgroundClick(e) {
      let bg = this.$refs.background
      if (e.toElement === bg) {
        this.edit.target = null
        this.edit.index = -1
      }
    },
    enableCreateMode(index) {
      let msgs = this.scene.messages
      let last = msgs[index - 1]
      let sender = last ? last.sender : '......'
      let newMsg = new Message({
        sender,
        content: '',
        autoNext: true
      })
      this.scene.messages.splice(index + 1, 0, newMsg)
      this.edit.mode = 'edit'
      this.edit.field = 'content'
      this.edit.target = newMsg
      this.edit.index = index + 1
      this.edit.tmpInput = ''
      this.$nextTick(() => {
        this.$refs.inputField.focus()
      })
      this.resetEditInputSize()
    },
    setMsgSSML(opts = {}){
      let msg = this.messageMenu.msg
      if (!msg) return
      let ssml
      if (typeof opts === 'string') {
        ssml = opts
      } else if (typeof opts === 'object') {
        if (opts.prompt) {
          return this.prompt({
            label: 'please input ssml',
            default: msg.ssml ? msg.ssml : '<speak>[請覆蓋掉這些字]</speak>',
            placeholder: '<speak>.........</speak>'
          }).then((result) => {
            if (result.type === 'input-value') {
              msg.ssml = result.input
            }
          })
        }
      } else {
        console.warn('setMsgSSML: unknow type of ', opts)
        return
      }
      if (opts.remove) {
        msg.ssml = null
      } else if (ssml) {
        msg.ssml = ssml
      }
    },
    enableEditMode(msg, index, targetType = this.edit.field) {
      this.edit.mode = 'edit'
      this.edit.field = targetType
      this.edit.target = msg
      this.edit.index = index
      this.edit.tmpInput = msg[targetType]
      this.$nextTick(() => {
        this.$refs.inputField.focus()
      })
      this.resetEditInputSize()
    },
    clearEditSelect() {
      this.edit.mode = 'create'
      this.edit.field = 'content'
      this.edit.target = null
      this.edit.index = -1
      this.edit.tmpInput = ''
    },
    editInputEnter(e){
      let shift = e.shiftKey
      if(this.$md.mobile()){
      }else{
        if(!shift){
          this.editInputSubmit()
        }
      }
    },
    /**
     * 在底下的輸入框按enter時觸發
     */
    editInputSubmit() {
      let msgs = this.scene.messages
      let last = msgs[this.edit.index - 1]
      let sender = last ? last.sender : '......'
      let input = this.edit.tmpInput.trim()
      if (input.length === 0) return
      // console.log('input:', input)
      // console.log('edit...', JSON.stringify(this.edit, null, 2))
      // 不管模式，只要新增sender，就會同步新增到nameChips裡面
      if (this.edit.field === 'sender') {
        if (!this.nameChips.list.includes(input)) {
          this.nameChips.list.push(input)
        }
      }
      let target =
        this.edit.target ||
        new Message({
          sender,
          content: input,
          autoNext: true
        })
      if (this.edit.mode === 'edit') {
        if (this.editCheckDuplicate(target, this.edit.field, input)) {
          target[this.edit.field] = input
          if (this.edit.field === 'id') {
            target.showId = true
          }
          // target.resetContentHtml()
          this.clearEditSelect()
        }
      } else if (this.edit.mode === 'create') {
        target.sender = this.nameChips.lastChoice
        this.scene.messages.push(target)
        this.$set(target, '_page', 0)
        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight)
          this.$refs.inputField.focus()
        })
        this.clearEditSelect()
      } else {
        console.warn(`unknow edit.mode: ${this.edit.mode}`)
      }
      this.resetEditInputSize()
      this.uploadScene()
    },
    resetEditInputSize(){
      this.$refs.inputField.style.height = 'calc(1.5rem + 4px)'
    },
    editInputKeyup() {
      // 捨棄原本使用 scrollHeight 的方式
      // 改為計算行數
      let p = -1
      let lineCount = 1
      let input = this.edit.tmpInput
      while((p = input.indexOf('\n', p + 1)) > -1){
        if(++lineCount > 2){
          break
        }
      }
      this.styles.inputFieldHeight = `calc(${lineCount * 1.5}rem + 4px)`
    },
    editCheckDuplicate(target, field, input) {
      switch (field) {
        case 'id':
        case 'sender':
        case 'content':
      }
      return true
    },
    onEditTextEnter(e) {
      if (!e.shiftKey) {
        let i = this.edit.index + 1
        if (i < this.scene.messages.length) {
          this.enableEditMode(this.scene.messages[i], i)
        } else {
          // TODO create element to edit
        }
      }
    },
    // 關閉所有的menu，如果有新的也要加到底下的list裡
    hideAllMenu() {
      let list = [
        'selectionMenu',
        'selectionCardMenu',
        'selectionActionMenu',
        'messageMenu',
        'roleMenu'
      ]
      for (let key of list) {
        this[key].show = false
      }
    },
    // ----------------------------------------- methods for Selection MENU
    /**
     * @param {Number} mIndex
     * @param {Number} sIndex selection的index
     * @param {Number} aIndex alias的index
     */
    showSelectionItemMenu(mIndex, sIndex, aIndex, event) {
      this.hideAllMenu()
      this.selectionMenu.show = true
      this.selectionMenu.x = event.clientX + 10
      this.selectionMenu.y = event.clientY - 50
      this.selectionMenu.mIndex = mIndex
      this.selectionMenu.sIndex = sIndex
      this.selectionMenu.aIndex = aIndex
    },
    removeSelectionAlias() {
      let msgs = this.scene.messages
      let mIndex = this.selectionMenu.mIndex
      let sIndex = this.selectionMenu.sIndex
      let aIndex = this.selectionMenu.aIndex
      let msg = msgs[mIndex]
      if (msg && msg.selections[sIndex]) {
        let selection = msg.selections[sIndex]
        if (aIndex >= 0) {
          selection.alias.splice(aIndex, 1)
        } else {
          if (selection.alias.length > 0) {
            selection.key = selection.alias[0]
            selection.alias.splice(0, 1)
          } else {
            msg.selections.splice(sIndex, 1)
          }
        }
      }
    },
    // ----------------------------------------- methods for Selection Card MENU
    showSelectionCardMenu(mIndex, sIndex, event) {
      this.hideAllMenu()
      this.selectionCardMenu.show = true
      this.selectionCardMenu.x = event.clientX + 10
      this.selectionCardMenu.y = event.clientY - 50
      this.selectionCardMenu.mIndex = mIndex
      this.selectionCardMenu.sIndex = sIndex
    },
    removeSelection() {
      let msgs = this.scene.messages
      let mIndex = this.selectionCardMenu.mIndex
      let sIndex = this.selectionCardMenu.sIndex
      let msg = msgs[mIndex]
      if (msg && msg.selections) {
        msg.selections.splice(sIndex, 1)
      }
    },
    newSelection() {
      let msgs = this.scene.messages
      let mIndex = this.selectionCardMenu.mIndex
      // let sIndex = this.selectionCardMenu.sIndex
      let msg = msgs[mIndex]
      if (msg) {
        if (!msg.selections) {
          msg.selections = []
        }
        if(msg.selectMode === 'advance'){
          msg.selections.push(
            new Message.Selection({
              key: '',
              alias: [],
              data: {
                subSelections: [
                  {
                    key: '',
                    data: {
                      target: ''
                    },
                    action: Message.Selection.Action.TO
                  },
                  {
                    key: '',
                    data: {
                      target: ''
                    },
                    action: Message.Selection.Action.TO
                  }
                ]
              }
            })
          )
        }else{
          msg.selections.push(
            new Message.Selection({
              key: '',
              alias: [],
              data: {
                target: ''
              },
              action: Message.Selection.Action.TO
            })
          )
        }
        this.$nextTick(() => {
          msg._page = msg.selections.length - 1
        })
      }
    },
    // ----------------------------------------- methods for Selection Action MENU
    showSelectionActionMenu(mIndex, sIndex, event) {
      this.hideAllMenu()
      // TODO
      // this.selectionActionMenu.show = true
      // this.selectionActionMenu.x = event.clientX + 10
      // this.selectionActionMenu.y = event.clientY - 50
      // this.selectionActionMenu.mIndex = mIndex
      // this.selectionActionMenu.sIndex = sIndex
    },
    // ----------------------------------------- methods for Message MENU
    showMessageMenu(i, event) {
      this.hideAllMenu()
      this.messageMenu.show = true
      this.messageMenu.x = event.clientX + 10
      this.messageMenu.y = event.clientY - 50
      this.messageMenu.index = i
      this.messageMenu.msg = this.scene.messages[i]
    },
    async showSetMessageNextPrompt(opts = {}) {
      let msg = this.messageMenu.msg
      if (!msg) return
      let result = await this.prompt({
        label: 'please input message id',
        default: msg.next ? msg.next : '',
        hint: '<scene id>/<message id> | <message id>'
      })
      if (result.type === 'input-value') {
        if (result.input) {
          msg.next = result.input
        } else {
          msg.next = null
        }
      }
    },
    setMessageHint(opts = {}) {
      let msg = this.messageMenu.msg
      if (!msg) return
      let hint
      if (typeof opts === 'string') {
        hint = opts
      } else if (typeof opts === 'object') {
        if (opts.prompt) {
          return this.prompt({
            label: 'please input hint message',
            default: msg.hint ? msg.hint : '',
            placeholder: 'some hint message'
            // hint: ''
          }).then((result) => {
            if (result.type === 'input-value') {
              msg.hint = result.input
            }
          })
        }
      } else {
        console.warn('setMessageHint: unknow type of ', opts)
        return
      }
      if (opts.remove) {
        msg.hint = null
      } else if (hint) {
        msg.hint = hint
      }
    },
    initMsgSelections(opts = {}) {
      let msg = this.messageMenu.msg
      this.$set(msg, '_page', 0)
      if(opts.advance){
        msg.selectMode = 'advance'
        msg.selections = [
          new Message.Selection({
            key: '',
            alias: [],
            data: {
              subSelections: [
                {
                  key: '',
                  data: {
                    target: ''
                  },
                  action: Message.Selection.Action.TO
                },
                {
                  key: '',
                  data: {
                    target: ''
                  },
                  action: Message.Selection.Action.TO
                }
              ]
            }
          })
        ]
      }else{
        msg.selectMode = 'closest'
        msg.selections = [
          new Message.Selection({
            key: ''
          })
        ]
      }
    },
    removeMessage(i) {
      this.scene.messages.splice(this.messageMenu.index, 1)
    },
    removeMessageAudio(){
      // server 部分定時自動刪除，這邊不處理
      delete this.messageMenu.msg.audio
    },
    showChangeIdPrompt() {
      let msg = this.messageMenu.msg
      // TODO
    },
    // ----------------------------------------- methods for Role MENU
    showRoleMenu(roleName, event) {
      this.hideAllMenu()
      this.roleMenu.show = true
      this.roleMenu.x = event.clientX + 10
      this.roleMenu.y = event.clientY - 50
      this.roleMenu.role = roleName
    },
    showRoleChangePrompt() {
      let val = window.prompt(
        `replace "${this.roleMenu.role}" to?`,
        this.roleMenu.role
      )
      if (val) {
        this.replaceRoleName(this.roleMenu.role, val.trim())
      }
    },
    showRoleAddPrompt() {
      let val = window.prompt('new role name:', 'new role name')
      if (val) {
        let role = val.trim()
        if (!this.nameChips.list.find((roleN) => roleN === role)) {
          this.nameChips.list.push(role)
        }
      }
    },
    replaceRoleName(before, after) {
      console.log('replaceRoleName(before, after)', before, after)
      if (this.nameChips.list.find((role) => role === after)) {
        // 如果把名字改成重複的 => 取消操作
        return
      }
      for (let msg of this.scene.messages) {
        if (msg.sender === before) {
          msg.sender = after
        }
      }
      for (let i in this.nameChips.list) {
        if (this.nameChips.list[i] === before) {
          this.nameChips.list[i] = after
          break
        }
      }
    },
    /**
     * 將"特殊的角色"轉換為"可顯示的名稱"
     */
    nameChipText(name){
      // TODO 這邊之後可能會需要根據語系的不同做額外調整
      return Message.getRoleName(name) || name
    },
    onNameChipClick(name) {
      this.nameChips.lastChoice = name
      if (this.edit.target) {
        this.edit.target.sender = name
      }
    },
    onSelectionCardEvent(e){
      console.log('onSelectionCardEvent', e)
      let mouseEvent = e.event
      switch(e.type){
        case 'card-menu':
          this.showSelectionCardMenu(e.mIndex, e.sIndex, mouseEvent)
          mouseEvent.preventDefault()
          break
        case 'item-menu':
          this.showSelectionItemMenu(e.mIndex, e.sIndex, e.aIndex, mouseEvent)
          mouseEvent.preventDefault()
          break
        case 'action-menu':
          this.showSelectionActionMenu(e.mIndex, e.sIndex, mouseEvent)
          mouseEvent.preventDefault()
          break
      }
    }
  }
}
</script>
<style>
.vue-typer .custom.char {
  color: white;
}
input:focus {
  outline-width: 0px;
}
html {
  overflow-y: hidden !important;
}
</style>
<style scoped>
.h-100 {
  height: 100%;
}
.background {
  width: 100vw;
  height: calc(100% - 68px);
  overflow-y: auto;
  background-color: #15202b;
  color: white;
}
.msg .role-name {
  font-size: 1rem;
  cursor: pointer;
}
.msg .msg-id {
  font-size: 1rem;
  cursor: pointer;
}
.user-response {
  font-size: 1rem;
}
.msg .content {
  display: inline-block;
  font-size: 1rem;
  padding: 5px;
  border: solid 1px #aaa;
  border-radius: 10px;
  max-width: 100%;
  min-width: 10px;
  cursor: pointer;
}
.msg .content.narrator{
  background-color: transparent;
  border: solid 1px white;
  margin-left: 2em;
  margin-right: 2em;
}
.msg .content.narrator.content-selected{
  border: solid 2px white;
}
.selections-bg input::placeholder {
  color: #aaa;
  font-size: 0.8rem;
}
.hover:hover {
  opacity: 0.85;
}
.c-pointer {
  cursor: pointer;
}
.msg .content:hover,
.msg .role-name:hover,
.msg .msg-id:hover {
  opacity: 0.85;
}
.msg hr{
  margin-top: 6px;
  margin-bottom: 6px;
}
.selections-item {
  border-radius: 10px;
  padding: 4px;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
  background-color: rgb(120, 120, 120);
}
/* 可調的部分 */
.msg .content {
  word-break: break-word;
  padding: 12px;
  background-color: #ffad1f;
  color: #fff;
  font-weight: bold;
}
.msg .content-selected {
  background-color: #d38e18;
  border: solid 1.2px lightskyblue;
}
.selections-item {
  color: #fff;
  font-weight: bold;
}
.selection-card-header{
  padding-right: 12px;
}
.selection-card-content{
  height:300px;
  overflow-y:scroll;
  padding-right: 12px;
}
.footer {
  z-index: 99;
  position: fixed;
  left: 0px;
  bottom: 0px;
  height: auto;
  width: 100%;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  background-color: #202020;
}
.footer .toolbar {
  height: 36px;
}
.footer .edit-tmp-input {
  /* height: 30px; */
  /* max-height:72px; */
  width: calc(100% - 28px);
  margin: 1px;
  margin-top: 2px;
  border: 1px;
  border-radius: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: rgba(150, 150, 150, 0.7);
  color: #fff;
  text-shadow: 2px 2px 3px #333;
}
.footer .edit-tmp-input:focus {
  background-color: rgba(120, 120, 120, 0.7);
  color: rgb(202, 202, 202);
}
.selections-change-page-area {
  height: 300px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0.5;
}
.noborder {
  border: 0px;
}
.noselect {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
.name-chips::-webkit-scrollbar {
  height: 2px;
}
.icon-color {
  color: #ffad1f;
}
.icon-bg {
  background-color: #ffad1f;
}
.selections-bg {
  background-color: #ffad1f;
}
.selections-change-page-area:hover {
  opacity: 1;
}
.btn-font {
  font-size: 1rem;
}
.role-name-selector-group {
}
.role-name-selector-group .v-btn {
  position: relative;
  z-index: 0;
  opacity: 0.5;
}
.role-name-selector {
  position: relative;
  padding-right: 20px;
  margin-right: -20px;
  z-index: 1;
}
.role-name-selector option {
  color: #888;
  padding: 4px 5px;
}
.role-name-selector::after {
  content: 'v';
}
</style>
<style lang="scss">
.icon-mic {
  fill: #747474;
  // fill: rgba(150, 150, 150, 0.7);
  border-radius: 50%;
  cursor: pointer;
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.recorder-area {
  // border: solid 1px pink;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.ar {
  &-player-wrapper {
    display: flex;
    align-items: center;
  }
  &-records {
    border: solid 1px skyblue;
    height: 100px;

    padding-top: 1px;
    overflow-y: auto;
    margin-bottom: 20px;

    &__record {
      width: 350px;

      height: 20px;
      line-height: 45px;
      border-bottom: 1px solid #e8e8e8;
      position: relative;
      padding: 20px 10px;
      margin: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #ffad1f;
      border-radius: 10px;
      // &--selected {
      //   // border: 1px solid #E8E8E8;
      //   // border-radius: 24px;
      //   // background-color: #FFFFFF;
      //   // margin-top: -1px;
      //   // padding: 0 34px;
      // }
    }

    &__text {
      color: rgba(84, 84, 84, 0.5);
      font-size: 16px;
    }

    &__rm {
      cursor: pointer;
      position: absolute;
      width: 6px;
      height: 6px;
      padding: 6px;
      line-height: 6px;
      margin: auto;
      left: 10px;
      bottom: 0;
      top: 0;
      color: rgb(244, 120, 90);
    }
  }
}
</style>
